import { Register } from './router'

const EmailConfirmationModule = () => {
	const emailconfirmation = require(/* webpackChunkName: "emailconfirmation" */ '../modules/email-confirmation')
	Register('emailConfirmation', emailconfirmation)
	return emailconfirmation
}

const RedefinePasswordModule = () => {
	const redefinepassword = require(/* webpackChunkName: "redefinepassword" */ '../modules/redefine-password')
	Register('redefinePassword', redefinepassword)
	return redefinepassword
}

export { EmailConfirmationModule, RedefinePasswordModule }
